import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypePageIndustrySkeleton } from './TypePageIndustry';

export interface TypeBlockIndustryBlocksFields {
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Symbol;
    paragraph?: EntryFieldTypes.Text;
    pages?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypePageIndustrySkeleton>>;
}

export type TypeBlockIndustryBlocksSkeleton = EntrySkeletonType<TypeBlockIndustryBlocksFields, 'blockIndustryBlocks'>;
export type TypeBlockIndustryBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockIndustryBlocksSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockIndustryBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockIndustryBlocks<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockIndustryBlocks';
}
